import React, { useState, useEffect } from 'react';
import './HeroSection.css';
import HeroJourney from './HeroJourney';

// LOCKED: hero copy, rotating phrases, timing and CTAs match the original site.

const HeroSection = () => {
  const rotatingPhrases = [
    { text: 'cut manual work', color: 'red' },
    { text: 'automate routine tasks', color: 'yellow' },
    { text: 'help customers find you', color: 'red' }
  ];
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fadeState, setFadeState] = useState('visible');

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('hidden');
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % rotatingPhrases.length);
        setFadeState('visible');
      }, 400);
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-grid">
          <div className="hero-content">
            <h1 className="hero-title">
              Digital Transformation for Growing Businesses<br />
              <span className="hero-subtitle-line">Simple, Practical and Profitable</span>
            </h1>
            
            <div className="hero-rotating-text">
              <p className="rotating-sentence">
                I am here to{' '}
                <span className={`rotating-phrase ${fadeState} color-${rotatingPhrases[currentIndex].color}`}>
                  {rotatingPhrases[currentIndex].text}
                </span>
                {' '}with AI-enabled digital solutions.
              </p>
            </div>
            
            <p className="hero-discovery-hint">
              Not sure where to start? Take our free Digital Audit.
            </p>

            <div className="hero-ctas">
              <a href="/business-discovery/" className="btn-hero-primary">
                Take the Free Digital Audit
              </a>
              <a href="/demo/" className="btn-hero-secondary">
                See Solutions →
              </a>
            </div>
          </div>
          
          <div className="hero-visual"><HeroJourney /></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
